import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {TipListOverviewComponent} from './tip-list-overview.component';

const routes: Routes = [
  {path: 'tiplists', component: TipListOverviewComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class TipListOverviewRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/tip-list/tip-list-overview/tip-list-overview-routing.module.ts